import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultClientStepSelector } from "store/user/(default)/client/default_client.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

export const FLOWS = {
  // CONTACT: "contact",
  // BASIC: "basic",
  // FINANCE: "finance",
  // KYB: "kyb",
  DOC: "doc",
};

export const useFlow = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [flow, setFlow] = useState(FLOWS.DOC);
  // -------------------------- REDUX ---------------------------
  const step = useSelector(defaultClientStepSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    // if (step === 0) {
    //   setFlow(FLOWS.CONTACT);
    // }
    // if (step === 1) {
    //   setFlow(FLOWS.BASIC);
    // }
    // if (step === 2) {
    //   setFlow(FLOWS.FINANCE);
    // }
    // if (step === 3) {
    //   setFlow(FLOWS.KYB);
    // }
    if (step === 0) {
      setFlow(FLOWS.DOC);
    }
  }, [step]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { flow };
};
